import React from "react"

import * as style from "./Pill.module.scss"

const Pill = ({
  pillType, text, className, color = "grey",
}) => (
  // eslint-disable-next-line max-len
  <div className={`${style.pill} ${pillType === 'pillLarge' ? style.pillLarge : ''} ${pillType === 'pillSmall' ? style.pillSmall : ''} ${color ?? ""} ${className ?? ""}`}>
    {text}
  </div>
)

export default Pill
